import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#003D82] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/86212dbabfd8f5fbe43a6aa5a3e48cb4/f863bbb11a69b2e7aeac905a5e1e635a.jpeg" 
              alt="EduGlobe Campus"
              title="EduGlobe Campus - Études à l'étranger"
              className="h-16 w-auto mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-sm text-gray-300">
              Votre partenaire de confiance pour vos études à l'étranger en France, au Canada et en Belgique.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Accueil</Link></li>
              <li><Link to="/a-propos" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">À Propos</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Nos Services</Link></li>
              <li><Link to="/destinations" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Destinations</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start">
                <i className="ri-map-pin-fill text-[#FF6B35] mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>Lomé Hedzranawoe, ancien OTR, Lomé, Togo</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-fill text-[#FF6B35] mr-2 w-5 h-5 flex items-center justify-center"></i>
                <a href="mailto:eduglobecampus@gmail.com" className="hover:text-[#FF6B35] transition-colors cursor-pointer">eduglobecampus@gmail.com</a>
              </li>
              <li className="flex items-center">
                <i className="ri-whatsapp-fill text-[#FF6B35] mr-2 w-5 h-5 flex items-center justify-center"></i>
                <a href="https://wa.me/22892620409" className="hover:text-[#FF6B35] transition-colors cursor-pointer">+228 92 62 04 09</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Suivez-nous</h4>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-tiktok-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm text-gray-300">
          <p>&copy; {new Date().getFullYear()} EduGlobe Campus. Tous droits réservés. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Powered by Readdy</a></p>
        </div>
      </div>
    </footer>
  );
}
